module.exports = __webpack_public_path__ + "eccc955da7baf4643af943b531c3b554.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-1080.webp.png
// module id = 453
// module chunks = 0